import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./post.css";

const LatestPostsSection = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [sponsors, setSponsors] = useState([]);
  const [currentSet, setCurrentSet] = useState(0);
  const sponsorsPerSet = 4;
  useEffect(() => {
    const fetchSponsors = async () => {
      try {
        const response = await fetch(
          "https://atabackend.quindl.com/sponsorship/get"
        );
        const data = await response.json();
        console.log(data);
        setSponsors(data);
      } catch (error) {
        console.error("Error fetching sponsors:", error);
      }
    };
    fetchSponsors();
  }, []);

  useEffect(() => {
    if (sponsors.length <= sponsorsPerSet) return;

    const interval = setInterval(() => {
      setCurrentSet((prev) => {
        const totalSets = Math.ceil(sponsors.length / sponsorsPerSet);
        return (prev + 1) % totalSets;
      });
    }, 3000);

    return () => clearInterval(interval);
  }, [sponsors.length]);

  const handleImageError = (e) => {
    e.target.onerror = null;
    e.target.src = "https://via.placeholder.com/150";
  };

  const getCurrentSponsors = () => {
    const startIndex = currentSet * sponsorsPerSet;
    return sponsors.slice(startIndex, startIndex + sponsorsPerSet);
  };

  useEffect(() => {
    const fetchLatestPosts = async () => {
      try {
        const response = await fetch(
          "https://atabackend.quindl.com/blog/get"
        );
        const allPosts = await response.json();

        // Sort posts by date and get latest 3
        const latestPosts = allPosts
          .sort((a, b) => new Date(b.date) - new Date(a.date))
          .slice(0, 3);

        setPosts(latestPosts);
        setLoading(false);
      } catch (err) {
        setError(err);
        setLoading(false);
      }
    };

    fetchLatestPosts();
  }, []);

  if (loading) {
    return (
      <div className="w-full py-12 px-4 bg-[#F8F8FA] text-center">
        <div className="max-w-4xl mx-auto">
          <div className="animate-pulse text-gray-500 font-semibold">
            Loading latest posts...
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="w-full py-16 px-4 bg-[#F8F8FA] text-center">
        <div className="max-w-7xl mx-auto">
          <div className="text-red-500">Error loading posts</div>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full py-16 px-0 bg-[#F8F8FA]">
      <div className="w-full h-[150px] bg-[#25223D] rounded-bl-3xl overflow-hidden">
        <div className="flex items-center justify-center h-full">
          <div className="w-[800px] relative overflow-hidden">
            {" "}
            {/* Fixed width container */}
            <div className="flex justify-center gap-16 transition-transform duration-500 ease-in-out">
              {getCurrentSponsors().map((sponsor, index) => {
                const encodedImageUrl = `https://atabackend.quindl.com/uploads/${encodeURIComponent(
                  sponsor.image
                )}`;

                return (
                  <div
                    key={`${sponsor._id}-${index}`}
                    className="w-32 h-32 flex items-center justify-center flex-shrink-0"
                  >
                    <img
                      src={encodedImageUrl}
                      alt={sponsor.name || "Sponsor Image"}
                      className="max-w-1/2 max-h-1/2 object-contain"
                      onError={handleImageError}
                      onClick={() => {
                        const link =
                          sponsor.link.startsWith("http://") ||
                          sponsor.link.startsWith("https://")
                            ? sponsor.link
                            : `http://${sponsor.link}`;
                        window.open(link, "_blank");
                      }}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 mt-12">
          <h2 className="text-4xl font-bold text-[#E16811] mb-4">
            Our Latest Post
          </h2>
          <p className="text-gray-600 text-lg">
            All the Blogs / Post published by <br /> Adelaide Tamil Association
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 justify-items-center">
          {posts.map((post) => (
            <div
              key={post._id}
              className="w-full max-w-[400px] bg-white rounded-xl overflow-hidden shadow-lg transition-all duration-300 hover:scale-105 hover:shadow-xl hover-orange-shadow"
            >
              <div className="aspect-w-16 aspect-h-9 overflow-hidden relative bg-gradient-to-br from-gray-50 to-gray-100">
                <img
                  src={`https://atabackend.quindl.com/uploads/${post.image}`}
                  alt={post.name}
                  className="w-full h-[300px] object-contain"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/assets/post-placeholder.svg";
                  }}
                />
              </div>
              <div className="p-6 text-center">
                <h3 className="text-xl font-semibold text-gray-800 mb-4 line-clamp-2 min-h-[3.5rem]">
                  {post.name}
                </h3>
                <div className="mt-4">
                  <Link
                    to={`/blog/${post._id}`}
                    className="inline-block w-full sm:w-auto px-8 py-3 text-[#E16811] border-2 border-[#E16811] rounded-full hover:bg-[#E16811] hover:text-white transition-all duration-300 font-medium text-center"
                  >
                    Read More
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LatestPostsSection;
